{
  "guide": "guide",
  "unable-to-load-article": "Kunde inte ladda {{type}} med id {{id}}",
  "Resources": "Verktyg",
  "Related": "Relaterat material",
  "Back to collection": "Tillbaka till Galleriet",
  "Are you sure that you want to cancel your enrolment in this course?": "Är du säker på att du vill avbryta din registering?",
  "Application for {{product}}": "Ansökan för {{product}}",
  "Upcoming": "Kommande",
  "provider-application-required": "Du måste registrera dig för att kunna ansöka till den här kursen.",
  "provider-application-pending": "Du väntar på att få din access till {{provider}} godkänd.",
  "request-access": "Ansök",
  "provider-access-approved": "Din licens till {{provider}} blev godkänd",
  "provider-access-pending": "Din förfrågan om access till {{provider}} har skickats",
  "Start": "Påbörja",
  "Open": "Öppna",
  "View Completed": "Se genomfört lärobjekt",
  "Continue": "Fortsätt",
  "Retake": "Gå om kursen",
  "Registration failed": "Registrering misslyckades",
  "Cancel enrollment": "Avbryt registrering",
  "Follow link": "Fortsätt",
  "Go to course": "Gå till lärobjektet",
  "pending approval": "Väntar på godkännande",
  "not a member of required groups": "Behörighet krävs",
  "Learning path": "Lärväg",
  "Discussions": "Diskussion",
  "Reflections": "Reflektion",
  "Participants": "Deltagare",
  "Description": "Beskrivning",
  "Post": "Inlägg",
  "Reflection": "Reflektion",
  "The module content cannot be displayed on this page using your current browser.": "Webbläsaren du använder stödjer inte innehållet.",
  "Click the link below to open the module in a new tab.": "Klicka på länken nedan för att öppna lärobjektet i en ny flik",
  "Go to module": "Gå till lärobjektet.",
  "There is no description": "Beskrivning saknas.",
  "There are no participants yet": "Det finns inga deltagare än.",
  "total-participants": "Den här lärvägen har en deltagare.",
  "total-participants_plural": "Den här lärvägen har {{count}} deltagare.",
  "all-enrollments": "Alla tillfällen har totalt en deltagare.",
  "all-enrollments_plural": "Alla tillfällen har totalt {{count}} deltagare.",
  "total-enrollments": "Det här tillfället har totalt en deltagare.",
  "total-enrollments_plural": "Det här tillfället har totalt {{count}} deltagare.",
  "Apply": "Ansök",
  "Enroll": "Anmäl dig",
  "Enrolled": "Anmäld",
  "Ongoing": "Pågående",
  "Cancel waitlist": "Avbryt väntelistan",
  "Join waitlist": "Ställ dig på väntelista",
  "No seats available": "Inga platser tillgängliga",
  "You will be added if a seat becomes available": "Du blir tillagd om en plats blir ledig",
  "Enrolled successfully": "Du är anmäld",
  "Cancelled enrollment successfully": "Du är avbokad",
  "Add to calendar": "Lägg till i kalender",
  "Web calendars": "Webbkalendrar",
  "iCal file downloaded successfully.": "iCal-fil har laddats ned. Öppna filen för att lägga till den i din kalender",
  "Event opened with calendar: {{calendar}}": "Event öppnat med kalender: {{calendar}}",
  "Go to webinar": "Gå till webbinarium",
  "mark-complete" : "markera som slutförd",
  "completed": "klar",
  "no-registration": "Du är inte registrerad på det här lärandet",
  "Your browser is currently not supported. Please use Chrome or Edge-Chromium.": "Din webbläsare stöds inte. Vänligen byt till Chrome eller Edge-Chromium",
  "mandatory-expires": "Det här lärandet är obligatoriskt. Det utgår om {{count}} dagar",
  "mandatory-expires-plural": "Det här lärandet är obligatoriskt och utgår om {{count}} dagar",
  "mandatory-expires-singular": "Det här lärandet är obligatoriskt och utgår om {{count}} dag",
  "mandatory-expired": "Det här lärandet är obligatoriskt och har utgått",
  "retake-modal-header": "Gå om kursen",
  "retake-modal-message": "Dina existerande framsteg är sparade men kursen kommer att flyttas tillbaka till Påbörjat-sektionen",
  "Fill in competency assessment": "Fyll i bedömningen av kompetensen"
}
